import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Christopher Davies',
    title: "Azure/.Net/iOS/Android/Maui developer",
    desciption:"WORK IN PROGRESS. BUILDING NEW SITE FROM WEB TEMPLATE. IMAGE ON LEFT NOT ME ;-) Life may be a meandering path but don't worry about it, rather enjoy it. It is about the journey, not the destination so explore all that comes your way, learn and grow from it, for this journey only happens once.",
    image: 'https://avatars.githubusercontent.com/u/85482640?v=4',
    resumePdf: resume
}
